<label class="mr-2" data-testid="date-range-label">{{ calendarLabel }}</label>
@if (userDateFormat) {
    <p-datePicker
        #datePicker
        [firstDayOfWeek]="firstDayOfWeek"
        [showWeek]="true"
        [dateFormat]="userDateFormat"
        [showIcon]="true"
        [(ngModel)]="dateRange"
        selectionMode="range"
        (onSelect)="onSelect()"
        (onClickOutside)="onClickOutside()"
        (onClose)="onClose()"
        (keydown)="onKeydown($event)"
        [panelStyle]="{ 'margin-left': '-30px' }"
    >
        <ng-template pTemplate="footer">
            <div
                pTooltip="{{ 'dashboard_calendar_proFeature' | translate }}"
                [tooltipDisabled]="licenseStatePro"
                tooltipPosition="left"
                style="display: inline-block"
                class="w-full"
            >
                <div class="grid grid-cols-12 gap-x-4 gap-y-0 mt-4">
                    @for (btn of quickSelectButtons; track btn.id) {
                        <div class="col-span-6">
                            <button
                                class="w-full mb-2 p-button-outlined"
                                pButton
                                severity="secondary"
                                type="button"
                                [disabled]="!licenseStatePro"
                                (click)="selectDateRange(btn.id)"
                            >
                                {{ btn.label | translate }}
                            </button>
                        </div>
                    }
                </div>
            </div>
        </ng-template>
    </p-datePicker>
}
